<script lang="ts">
  export let padded = true;
  export let className = '';
  export let tag: keyof HTMLElementTagNameMap = 'section';
  export let variant: 'default' | 'muted' = 'default';

  let restClass = '';
  let restProps: Record<string, any> = {};

  $: ({ class: restClass = '', ...restProps } = $$restProps as Record<string, any>);
  $: computedClass = [
    'surface-card',
    padded ? '' : 'surface-card--bare',
    `surface-card--${variant}`,
    className,
    restClass
  ]
    .filter(Boolean)
    .join(' ');
</script>

<svelte:element this={tag} class={computedClass} {...restProps}>
  <slot />
</svelte:element>

<style>
  .surface-card {
    padding: var(--space-4);
    border-radius: var(--radius-xl);
    background: rgba(16, 18, 26, 0.65);
    border: 1px solid rgba(255, 255, 255, 0.05);
    backdrop-filter: blur(18px);
    box-shadow: var(--shadow-md);
  }

  .surface-card--bare {
    padding: 0;
  }

  .surface-card--muted {
    background: rgba(255, 255, 255, 0.05);
  }
</style>
